import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './InventoryCounts.frontend.types'

@Injectable({ providedIn: 'root' })
export class InventoryCounts_create_recount_task_flowService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run(inParams: { countTaskId: number, isOverride?: boolean }): Promise<{ errors?: string[], recountTaskId?: number, discrepancyId?: number }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.countTaskId)) {
      missingRequiredInParams.push('\'countTaskId\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/InventoryCounts/functions/create_recount_task_flow`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }

}

